import { atom } from "jotai";
import { Pageable } from "../../../services/pageable";
import { ParticipationsDTO } from "../../../store/participations/models/dto";
import { StatusEnum } from "../../../store/users/models/internal";

export const participationPagination = atom<
  Pageable.T<Exclude<keyof ParticipationsDTO.Responses.GetSingle.T, "editable">>
>({
  pagination: {
    size: 20,
    page: 0,
  },
  sorting: {
    direction: "desc",
    field: "createdDate",
  },
});

export const selectedLaunch = atom<
  | {
      id: string;
      launchName: string;
    }
  | undefined
>(undefined);

export const selectedKycStatus = atom<StatusEnum | undefined>(undefined);
